import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';

interface Business {
  name: string;
  address: string;
}

@Component({
  selector: 'smb-invoicing-payment-business-page',
  templateUrl: './payment-business.component.html',
  styleUrls: ['./payment-business.component.scss'],
  standalone: true,
  imports: [MatIcon, RouterLink, AsyncPipe, LexiconModule],
})
export class PaymentBusinessComponent implements OnInit {
  @Input() businessId: string;

  loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  errorCode$$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  business$: Observable<Business>;

  constructor(private accountGroupService: AccountGroupService) {}

  ngOnInit(): void {
    this.business$ = this.accountGroupService.get(this.businessId, new ProjectionFilter({ napData: true })).pipe(
      map((accountGroup) => {
        // Get doesn't actually return a 404. So if the nap data is missing
        // assume we couldn't find the business.
        if (!accountGroup || !accountGroup.napData) {
          throw new HttpErrorResponse({ status: 404 });
        }
        return {
          name: accountGroup?.napData?.companyName,
          address: [
            accountGroup?.napData?.address,
            accountGroup?.napData?.address2,
            accountGroup?.napData?.city,
            accountGroup?.napData?.country,
          ]
            .filter((p) => !!p)
            .join(', '),
        };
      }),
      tap(() => this.loading$$.next(false)),
      catchError((err) => {
        this.loading$$.next(false);
        this.errorCode$$.next(err.status);
        return of(null);
      }),
    );
  }
}
